import {Component, inject} from '@angular/core';
import {Subscription} from 'rxjs';
import {PageNavigationComponent} from '../../components/page-navigation/page-navigation.component';
import {Step} from '../../models/consultation/Step';
import {ConsultationService} from '../../services/consultation.service';
import {WizardProgressComponent} from './components/wizard-progress/wizard-progress.component';

@Component({
    selector: 'app-consultation',
    imports: [
        PageNavigationComponent,
        WizardProgressComponent
    ],
    templateUrl: './consultation.component.html',
    styleUrl: './consultation.component.scss'
})
export class ConsultationComponent {

    // region Variables



    // endregion

    // Constructor
    constructor() {
    }

    // Init
    ngOnInit() {


    }

    // Destroy
    ngOnDestroy() {
    }

}
